import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CircleExclamationIcon = ({
  color = 'black',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
  title = 'Error',
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    width={width}
    title={title}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle cx={Number(width) / 2} cy={Number(width) / 2} r={Number(width) / 2} />
        <path
          d="M20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 Z M20,3 C10.6111593,3 3,10.6111593 3,20 C3,29.3888407 10.6111593,37 20,37 C29.3888407,37 37,29.3888407 37,20 C37,10.6111593 29.3888407,3 20,3 Z"
          id="Border"
          fill={getSemanticTextColor(color)}
        />
        <path
          d="M20.0139665,25 C21.4944134,25 22.472067,26.0164835 22.5,27.5 C22.5,28.9285714 21.5223464,30 20.0139665,30 L20.0139665,30 L19.9860335,30 C18.5055866,30 17.5,28.9285714 17.5,27.5 C17.5,26.0164835 18.5335196,25 20.0139665,25 Z M21.4692735,10.0004198 L21.498221,10.0016787 C22.0495786,10.0336668 22.4706109,10.5065619 22.4386228,11.0579195 L22.4386228,11.0579195 L21.858454,21.0579195 C21.8277691,21.5868167 21.3899193,22 20.8601328,22 L20.8601328,22 L19.1398672,22 C18.6100807,22 18.1722309,21.5868167 18.141546,21.0579195 L18.141546,21.0579195 L17.5613772,11.0579195 C17.5602583,11.0386333 17.5596984,11.0193187 17.5596984,11 C17.5596984,10.4477153 18.0074137,10 18.5596984,10 L18.5596984,10 L21.4692735,10.0004198 L21.4692735,10.0004198 Z"
          id="!-Exclamation-mark"
          fill={getSemanticTextColor(color)}
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
